import React, { useEffect } from 'react';
import { Row, Col, Button, Typography, Spin } from 'antd';
import { useAppContext } from './AppContext';
import XAxisArrow from './XAxisArrow';
import YAxisArrow from './YAxisArrow';

const { Text } = Typography;


const NineBoxPage = () => {
  const { filterTableData } = useAppContext();
  //const [tableData, setTableData] = React.useState(listOfEmployeeJSON);
  const { tableData,filteredTableData } = useAppContext();
  const [needImprovementCount, setNeedImprovementCount] = React.useState(0);
  const [expandableCount, setExpandableCount] = React.useState(0);
  const [topTalentCount, setTopTalentCount] = React.useState(0);
  const [needPerformanceManagementCount, setNeedPerformanceManagementCount] = React.useState(0);
  const [solidPerformerCount, setSolidPerformerCount] = React.useState(0);
  const [promotableCount, setPromotableCount] = React.useState(0);
  const [poorFitCount, setPoorFitCount] = React.useState(0);
  const [suitablyPlacedCount, setSuitablyPlacedCount] = React.useState(0);
  const [valuedProfessionalCount, setValuedProfessionalCount] = React.useState(0);
  const [needImprovementPercentage, setNeedImprovementPercentage] = React.useState(0);
  const [expandablePercentage, setExpandablePercentage] = React.useState(0);
  const [topTalentPercentage, setTopTalentPercentage] = React.useState(0);
  const [needPerformanceManagementPercentage, setNeedPerformanceManagementPercentage] = React.useState(0);
  const [solidPerformerPercentage, setSolidPerformerPercentage] = React.useState(0);
  const [promotablePercentage, setPromotablePercentage] = React.useState(0);
  const [poorFitPercentage, setPoorFitPercentage] = React.useState(0);
  const [suitablyPlacedPercentage, setSuitablyPlacedPercentage] = React.useState(0);
  const [valuedProfessionalPercentage, setValuedProfessionalPercentage] = React.useState(0);
  const [loading, setLoading] = React.useState(false);
  const { upName,reportType } = useAppContext();


  const buttons = [
    { percentBackColor: '#F5B7B1', count: needImprovementCount, text: 'Needs Improvement\n', percent: '  ' + needImprovementPercentage.toFixed(2) + '%', type: 'Low Performance\nHigh Potential', backColor: '#F9ECEC', color: '#FF3131', textColor: '#C51E1E', key: 'Needs Improvement' },
    { percentBackColor: '#A9DFBF', count: expandableCount, text: 'Expandable\n', percent: '  ' + expandablePercentage.toFixed(2) + '%', type: 'Medium Performance\nHigh Potential', backColor: '#DCF3D9', color: '#4CBB17', textColor: '#008000', key: 'Expandable' },
    { percentBackColor: 'black', count: topTalentCount, text: 'Top Talent\n', percent: '  ' + topTalentPercentage.toFixed(2) + '%', type: 'High Performance\nHigh Potential', backColor: '#DCF3D9', color: '#008000', textColor: '#008000', key: 'Top Talent' },
    { percentBackColor: '#F5B7B1', count: needPerformanceManagementCount, text: 'Needs Performance\nManagement\n', percent: '  ' + needPerformanceManagementPercentage.toFixed(2) + '%', type: 'Low Performance\nMedium Potential', backColor: '#F9ECEC', color: '#FF3131', textColor: '#C51E1E', key: 'Needs Performance Management' },
    { percentBackColor: 'black', count: solidPerformerCount, text: 'Solid Performer\n', percent: '  ' + solidPerformerPercentage.toFixed(2) + '%', type: 'Medium Performance\nMedium Potential', backColor: '#FCF3CF', color: '#FFC300', textColor: '#D68910', key: 'Solid Performer' },
    { percentBackColor: 'black', count: promotableCount, text: 'Promotable\n', percent: '  ' + promotablePercentage.toFixed(2) + '%', type: 'High Performance\nMedium Potential', backColor: '#DCF3D9', color: '#4CBB17', textColor: '#008000', key: 'Promotable' },
    { percentBackColor: '#F5B7B1', count: poorFitCount, text: 'Poor Fit\n', percent: '  ' + poorFitPercentage.toFixed(2) + '%', type: 'Low Performance\nLow Potential', backColor: '#F9ECEC', color: '#C51E1E', textColor: '#C51E1E', key: 'Poor Fit' },
    { percentBackColor: 'black', count: suitablyPlacedCount, text: 'Suitably Placed\n', percent: '  ' + suitablyPlacedPercentage.toFixed(2) + '%', type: 'Medium Performance\nLow Potential', backColor: '#FCF3CF', color: '#FFC300', textColor: '#D68910', key: 'Suitably Placed' },
    { percentBackColor: 'black', count: valuedProfessionalCount, text: 'Valued Professional\n', percent: '  ' + valuedProfessionalPercentage.toFixed(2) + '%', type: 'High Performance\nLow Potential', backColor: '#FCF3CF', color: '#FFC300', textColor: '#D68910', key: 'Valued Professional' },
  ];

  useEffect(() => {
    setLoading(true);
    
    // Use filteredTableData instead of applying our own filters
    // This ensures the 9-box counts reflect the current search filters
    let filteredResults = filteredTableData || [];

    const needImprovement = filteredResults.filter((item) => (item.nineboxmapping === 'Needs Improvement'));
    setNeedImprovementCount(needImprovement.length);
    const expandable = filteredResults.filter((item) => (item.nineboxmapping === 'Expandable'));
    setExpandableCount(expandable.length);
    const topTalent = filteredResults.filter((item) => (item.nineboxmapping === 'Top Talent'));
    setTopTalentCount(topTalent.length);
    const needPerformanceManagement = filteredResults.filter((item) => (item.nineboxmapping === 'Needs Performance Management'));
    setNeedPerformanceManagementCount(needPerformanceManagement.length);
    const solidPerformer = filteredResults.filter((item) => (item.nineboxmapping === 'Solid Performer'));
    setSolidPerformerCount(solidPerformer.length);
    const promotable = filteredResults.filter((item) => (item.nineboxmapping === 'Promotable'));
    setPromotableCount(promotable.length);
    const poorFit = filteredResults.filter((item) => (item.nineboxmapping === 'Poor Fit'));
    setPoorFitCount(poorFit.length);
    const suitablyPlaced = filteredResults.filter((item) => (item.nineboxmapping === 'Suitably Placed'));
    setSuitablyPlacedCount(suitablyPlaced.length);
    const valuedProfessional = filteredResults.filter((item) => (item.nineboxmapping === 'Valued Professional'));
    setValuedProfessionalCount(valuedProfessional.length);
    
    // Calculate percentages based on filtered results
    const totalCount = filteredResults.length;
    if (totalCount > 0) {
      setNeedImprovementPercentage((needImprovement.length / totalCount) * 100);
      setExpandablePercentage((expandable.length / totalCount) * 100);
      setTopTalentPercentage((topTalent.length / totalCount) * 100);
      setNeedPerformanceManagementPercentage((needPerformanceManagement.length / totalCount) * 100);
      setSolidPerformerPercentage((solidPerformer.length / totalCount) * 100);
      setPromotablePercentage((promotable.length / totalCount) * 100);
      setPoorFitPercentage((poorFit.length / totalCount) * 100);
      setSuitablyPlacedPercentage((suitablyPlaced.length / totalCount) * 100);
      setValuedProfessionalPercentage((valuedProfessional.length / totalCount) * 100);
    } else {
      // Set all percentages to 0 when no data
      setNeedImprovementPercentage(0);
      setExpandablePercentage(0);
      setTopTalentPercentage(0);
      setNeedPerformanceManagementPercentage(0);
      setSolidPerformerPercentage(0);
      setPromotablePercentage(0);
      setPoorFitPercentage(0);
      setSuitablyPlacedPercentage(0);
      setValuedProfessionalPercentage(0);
    }
    
    setLoading(false);
  }, [filteredTableData]); // Changed dependency to filteredTableData

  const handleButtonClick = (text) => {
    // Handle button click
   // console.log(`Button clicked: ${text}`);
    filterTableData(text);
  };

  const buttonStyle = {
    width: '160px', // Adjust the width
    height: '150px', // Adjust the height
    borderRadius: '11px', // Adjust the border-radius for curved edges
    marginBottom: '3px', // Adjust spacing between buttons
  };

  return (
    <Spin size="large" spinning={loading}>
      <div style={{ display: "flex", alignItems: "flex-start", }}>
        <div style={{ marginRight: '1px' }}>
          <YAxisArrow />
        </div>
        <div>


          <Row style={{ width: '490px' }}>
            {buttons.map((button, index) => (
              <Col span={8} key={index}>
                <Button
                  style={{
                    ...buttonStyle,
                    backgroundColor: button.backColor,
                    //background: 'transparent',
                    color: button.textColor,
                    border: `1px solid ${button.color}`,
                    whiteSpace: 'pre-line',
                    //fontWeight:'bold',
                    fontSize: '12px',
                  }}
                  onClick={() => handleButtonClick(button.key)}
                >
                  <div style={{ textAlign: 'center' }}>
                  <Text style={{ fontSize: '13px', color: button.textColor, fontWeight: 'bold' }}>{button.text}</Text>
                  <br />
                  <Text style={{ fontSize: '32px', color: button.textColor, fontWeight: 'bold' }}>{button.count}</Text>
                  <Text style={{ fontSize: '12px', color: button.textColor, marginLeft: 5 }}>{'\t'}{button.percent}</Text>
                  <br />
                  <Text style={{ fontSize: '11px', color: button.textColor }}>{button.type}</Text>
                  </div>
                </Button>
              </Col>
            ))}
          </Row>
          <Row>
            <Col>
              <div style={{ marginTop: '30px' }}>
                <XAxisArrow />
              </div>
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <Button style={{ border: `1px solid blue` }} onClick={() => handleButtonClick(null)}><Text style={{ color: 'blue' }}>Refresh 9 Box</Text></Button>
        </div>
            </Col>
          </Row>
          <Row>
            <Col style={{ marginLeft: '185px', marginTop: '2px' }}>
            </Col>
          </Row>
        </div>
        
      </div>
    </Spin>
  );
};

export default NineBoxPage;
